import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-exchange-card',
    templateUrl: './exchange-card.component.html',
    styleUrls: ['./exchange-card.component.scss']
})
export class ExchangeCardComponent implements OnInit {
    @Output() onSubmitForm = new EventEmitter<{ email: string; password?: string }>();
    @Input() title = 'Exchange Online';
    @Input() requiresPassword = false;

    public user = {
        email: '',
        password: ''
    };
    public hasError = false;

    constructor(private router: Router) {}

    ngOnInit() {}

    public handleSubmit(user: { email: string; password?: string }) {
        if (!user.email || (this.requiresPassword && !user.password)) {
            this.hasError = true;
            return;
        }
        this.onSubmitForm.emit(user);
        this.hasError = false;
    }

    public handleCancelForm() {
        this.router.navigate(['/auth']);
    }
}
